import { GEOCODE_API } from '../constants/AppConstants';

export default async (searchAddress, country) => {
  try {
    const response = await fetch(
      `${GEOCODE_API}?address=${encodeURIComponent(searchAddress)}&country=${encodeURIComponent(country)}`,
      { skipAuthHeader: true },
    );
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };

    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
